import React, { Component } from 'react';
// import App_data from "../config/App_data";
import FD from '../../RestAPI/fetchData';
// import GD from "../../RestAPI/getData";
import GMATSubscriptionCheck from '../../RestAPI/GMATSubscription';
import PartnerGMATSubscriptionCheck from '../../RestAPI/PartnerSubscription/GMATSubscription';
import language from '../../../assets/languages/language';
import ModalComponent from '../../Common/Modal';
import AlertMessage from '../../config/alertMessage';
import PDFModelComponent from '../../Common/PDFModel';
// import { getDeviceDetails } from "../../../../common/deviceDetails";
import { getIpAddress } from '../../../common/getIpAddress';
import QuestionNotFoundModal from '../../Common/questionNotFoundModel';
import App_data from '../../config/App_data';
import { showFailure } from '../../../common/toast';
import AppRoutes from '../../config/AppRoutes';
import Loader from '../../../common/loader';
/* eslint-disable*/
class GMATReadings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      alert_status_question_not_found: false,
      pdfAlert: false,
      MessageTitle: App_data.messageTitle_cfa,
      MessageContent: AlertMessage.messageContent_gmat,

      MessageTitleOnQuestionNotFound: `${language.LC().MESSAGE}`,
      ComingSoon: `${language.LC().COMING_SOON}`,

      readings: [],
      token: '',
      idname: '',
      chapterid: this.props.params.id,
      chapterName: '',
      ValidToken: false,
      chapter_id: '',
      no_result_display: '',
      subscriptionstatus: '',
      showFreePremium: true,
      selectedmenu: 'gmat',
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
      type: 'question',
      PDFDownloadType: 'Question',
      pdfLoading: true,
      pdfLoadingAnswer: true,
      PDFContentMessage: language.LC().PDFContentMessage,
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
    };
    this.toggleAlert = this.toggleAlert.bind(this);
    this.pdfAlertModel = this.pdfAlertModel.bind(this);
  }

  toggleAlert() {
    if (this.state.subscriptionstatus === 'free') {
      this.setState({
        alert_status: !this.state.alert_status,
      });
    } else {
      this.setState({
        alert_status_question_not_found: !this.state.alert_status_question_not_found,
      });
    }
  }

  pdfAlertModel() {
    this.setState({
      pdfAlert: !this.state.pdfAlert,
    });
  }
  //it is use to redirect page
  static contextTypes = {
    router: React.PropTypes.object,
  };

  //Function to redirect page to question bank page
  _getChapters = e => {
    this.context.router.push({
      pathname: AppRoutes.GMAT_QUESTION_BANK,
    });
  };

  //Function to redirect page to viewquestions page
  _getQuestions = (reading, e) => {
    // console.log('get00000=m,j,hjjkkjkj', reading);
    var user_data = { token: this.state.token, idname: this.state.idname };
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this._runCode('free', reading);
          this.setState({ subscriptionstatus: 'free' });
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });

          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                // console.log('resp.profileInfo.userStatus', resp.profileInfo);
                isInArray_var = await PartnerGMATSubscriptionCheck.checkGMATQuestionSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                if (isInArray_var) {
                  this._runCode('paid', reading);
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this._runCode('free', reading);
                  this.setState({ subscriptionstatus: 'free' });
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage === '' &&
          resp.profileInfo.cfaUnlimitedActiveExam === ''
        ) {
          this._runCode('free', reading);
          this.setState({ subscriptionstatus: 'free' });
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = GMATSubscriptionCheck.checkGMATQuestionSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                if (isInArray_var) {
                  this._runCode('paid', reading);
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this._runCode('free', reading);
                  this.setState({ subscriptionstatus: 'free' });
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      }
    });
  };

  _runCode(subscriptionstatus, reading) {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      reading_id: reading.id,
      chapter_id: this.state.chapterid,
      offset: 0,
      limit: 1,
      subscriptionstatus: subscriptionstatus,
    };

    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getQuestions', data).then(resp => {
      if (resp.success) {
        if (resp.questions.length || reading.type !== 'case_question') {
          // console.log('reading.type', reading);
          this.context.router.push({
            pathname: AppRoutes.GMAT_QUESTION_BANK_LIST_QUE.replace(
              ':chapter_no',
              reading.chapter_no,
            )
              .replace(':id', reading.id)
              .replace(':subscriptionstatus', subscriptionstatus)
              .replace(':reading', reading.reading),
          });
          // }
        } else {
          this.toggleAlert();
        }
      }
    });
  }
  //Function to redirect page on specifc questions
  _beginChapter = (reading, e) => {
    // console.log('reading----------------------------', reading);
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      reading_id: reading.id,
      chapter_id: this.state.chapterid,
      offset: 0,
      limit: 1,
      subscriptionstatus: this.state.subscriptionstatus,
    };
    if (reading.type === 'case_question') {
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/getCaseByReading', data).then(resp => {
        if (resp.success) {
          if (resp.questions.length) {
            this.context.router.push({
              pathname: AppRoutes.GMAT_BEGINCASE.replace(':chapterid', this.state.chapterid)
                .replace(':readingid', reading.id)
                .replace(':caseid', resp.questions[0].case_id)
                .replace(':case_offset', 0)
                .replace(':subscription', this.state.subscriptionstatus === 'paid' ? 1 : 0)
                .replace(':question_number', resp.questions[0].question_no)
                .replace(':offset', 0),
            });
          } else {
            this.toggleAlert();
          }
        }
      });
    } else if (reading.type === 'tab_question') {
      this.context.router.push({
        pathname: AppRoutes.GMAT_TAB.replace(':chapterid', this.state.chapterid)
          .replace(':readingid', reading.id)
          .replace(':subscription', this.state.subscriptionstatus === 'paid' ? 1 : 0)
          .replace(':question_id', 1)
          .replace(':offset', 0)
          .replace(':reading', reading.reading),
      });
    } else if (reading.type === 'graph_question') {
      this.context.router.push({
        pathname: AppRoutes.GMAT_GRAPH_MULTI_STATEMENT.replace(':chapterid', this.state.chapterid)
          .replace(':readingid', reading.id)
          .replace(':subscription', this.state.subscriptionstatus === 'paid' ? 1 : 0)
          .replace(':question_id', 1)
          .replace(':offset', 0)
          .replace(':reading', reading.reading),
      });
    } else if (reading.type === 'table_question') {
      this.context.router.push({
        pathname: AppRoutes.GMAT_TABLE.replace(':chapterid', this.state.chapterid)
          .replace(':readingid', reading.id)
          .replace(':subscription', this.state.subscriptionstatus === 'paid' ? 1 : 0)
          .replace(':question_id', 1)
          .replace(':offset', 0)
          .replace(':reading', reading.reading),
      });
    } else if (reading.type === 'two_part_question') {
      this.context.router.push({
        pathname: AppRoutes.GMAT_TWO_PART_STATEMENT.replace(':chapterid', this.state.chapterid)
          .replace(':readingid', reading.id)
          .replace(':subscription', this.state.subscriptionstatus === 'paid' ? 1 : 0)
          .replace(':question_id', 1)
          .replace(':offset', 0)
          .replace(':reading', reading.reading),
      });
    } else {
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/getQuestions', data).then(resp => {
        if (resp.success) {
          if (resp.questions.length) {
            this.context.router.push({
              pathname: AppRoutes.GMAT_QUESTION_BANK_VIEW_QUE.replace(
                ':notesid',
                this.state.chapterid,
              )
                .replace(':readingid', reading.id)
                .replace(':id', resp.questions[0].id)
                .replace(':offset', 0),
            });
          } else {
            this.toggleAlert();
          }
        }
      });
    }
  };

  //On Page Load,init this method
  async componentDidMount() {
    // api to get ip address
    const result = await getIpAddress();
    if (result) {
      this.setState({
        user_city: result.city,
        user_country: result.country,
        user_ip: result.query,
        user_state: result.region,
        user_continent: result.continent,
      });
    }
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });

    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      chapter: this.state.chapterid,
    };

    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getReadings', data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          readings: resp.readings,
          chapterName: resp.chaptername.chapter_name,
        });
        if (!resp.readings.length) {
          this.setState({ no_result_display: 'No Saved Questions' });
        }
      } else {
        this.setState({ ValidToken: false });
        showFailure('No readings found!!');
      }
      // return resp;
    });

    var user_data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({
            showFreePremium: true,
            subscriptionstatus: 'free',
          });
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                var isInArray_var_PDF = false;
                isInArray_var = await PartnerGMATSubscriptionCheck.checkGMATQuestionSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                if (isInArray_var) {
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this.setState({
                    subscriptionstatus: 'free',
                    showFreePremium: true,
                  });
                }
                isInArray_var_PDF = await PartnerGMATSubscriptionCheck.checkGMATQuestionSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  this.state.type,
                );

                // console.log('isInArray_var_PDF', isInArray_var_PDF);
                if (isInArray_var_PDF) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage === '' &&
          resp.profileInfo.cfaUnlimitedActiveExam === ''
        ) {
          // console.log('if working')
          this.setState({
            showFreePremium: true,
            subscriptionstatus: 'free',
          });
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              // console.log(resp_exam);
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                var isInArray_var_PDF = false;
                isInArray_var = GMATSubscriptionCheck.checkGMATQuestionSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                // console.log(isInArray_var);
                if (isInArray_var) {
                  // console.log('IF WORKING')
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this.setState({
                    subscriptionstatus: 'free',
                    showFreePremium: true,
                  });
                }
                isInArray_var_PDF = GMATSubscriptionCheck.checkGMATQuestionSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  this.state.type,
                );
                if (isInArray_var_PDF) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      }
    });
  }
  /*
------------------------------
  PDF DOWNLOAD Via Email
-------------------------------
*/

  getpdf = async e => {
    if (this.state.pdfLoading == false) {
      alert('Download is in progress....');
      return;
    }
    if (this.state.pdfLoadingAnswer == false) {
      alert('Please wait one process is in queue.');
      return;
    }
    var user_data = {
      token: this.state.token,
      idname: this.state.idname,
    };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(async resp => {
      // console.log(
      //   'resp.profileInforesp.profileInforesp.profileInforesp.profileInforesp.profileInfo',
      //   resp.profileInfo
      // );
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.toggleAlert();
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var_PDF = false;
                isInArray_var_PDF = await PartnerGMATSubscriptionCheck.checkGMATQuestionSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  this.state.type,
                );
                if (isInArray_var_PDF) {
                  this.setState({
                    pdfLoading: false,
                  });
                  // const result = getDeviceDetails();
                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/gmat_question_bank/Q-PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoading: true,
                        PDFDownloadType: 'Question',
                      });
                      this.pdfAlertModel();
                    } else if (!response.pdf) {
                      this.setState({
                        pdfLoading: true,
                        PDFDownloadType: 'Question',
                      });
                      this.pdfAlertModel();
                    }
                  });
                } else {
                  this.toggleAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected === '') {
          this.toggleAlert();
        } else {
          // console.log(
          //   'resssssssssssssssss-----------',
          //   resp.profileInfo.subscription_details
          // );
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              // console.log(resp_exam);
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var_PDF = false;

                isInArray_var_PDF = await GMATSubscriptionCheck.checkGMATQuestionSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  this.state.type,
                );
                if (isInArray_var_PDF) {
                  this.setState({
                    pdfLoading: false,
                  });
                  // const result = getDeviceDetails();
                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/gmat_question_bank/Q-PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoading: true,
                        PDFDownloadType: 'Question',
                      });
                      this.pdfAlertModel();
                    } else if (!response.pdf) {
                      this.setState({
                        pdfLoading: true,
                        PDFDownloadType: 'Question',
                      });
                      this.pdfAlertModel();
                    }
                  });
                } else {
                  this.toggleAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      }
    });
  };

  /*
--------------------------------
  PDF DOWNLOAD Via email Answer
--------------------------------
*/
  getpdfAnswer = async e => {
    if (this.state.pdfLoadingAnswer == false) {
      alert('Download is in progress....');
      return;
    }
    if (this.state.pdfLoading == false) {
      alert('Please wait one process is in queue.');
      return;
    }

    var user_data = {
      token: this.state.token,
      idname: this.state.idname,
    };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.toggleAlert();
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var_PDF = false;
                isInArray_var_PDF = await PartnerGMATSubscriptionCheck.checkGMATQuestionSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  this.state.type,
                );
                if (isInArray_var_PDF) {
                  this.setState({
                    pdfLoadingAnswer: false,
                  });
                  // const result = getDeviceDetails();
                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/gmat_question_bank/QA-PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoadingAnswer: true,
                        PDFDownloadType: 'Question/Answer',
                      });
                      this.pdfAlertModel();
                    } else if (!response.pdf) {
                      this.setState({
                        pdfLoadingAnswer: true,
                        PDFDownloadType: 'Question/Answer',
                      });
                      this.pdfAlertModel();
                    }
                  });
                } else {
                  this.toggleAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage === '' &&
          resp.profileInfo.cfaUnlimitedActiveExam === ''
        ) {
          this.toggleAlert();
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              // console.log(resp_exam);
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var_PDF = false;

                isInArray_var_PDF = await GMATSubscriptionCheck.checkGMATQuestionSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  this.state.type,
                );
                if (isInArray_var_PDF) {
                  this.setState({
                    pdfLoadingAnswer: false,
                  });
                  // const result = getDeviceDetails();
                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/gmat_question_bank/QA-PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoadingAnswer: true,
                        PDFDownloadType: 'Question/Answer',
                      });
                      this.pdfAlertModel();
                    } else if (!response.pdf) {
                      this.setState({
                        pdfLoadingAnswer: true,
                        PDFDownloadType: 'Question/Answer',
                      });
                      this.pdfAlertModel();
                    }
                  });
                } else {
                  this.toggleAlert();
                }
              } else {
                // console.log('fail');
              }
            },
          );
        }
      }
    });
  };

  goPremium() {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  }

  render() {
    let readings = this.state.readings;
    let data = '';

    if (this.state.readings.length) {
      data = readings.map((item, index) => {
        // console.log('item----------------', item.type);
        return (
          <tr key={index}>
            <td>{item.reading_no}.</td>
            <td>{item.reading}</td>
            {item.type === 'no_question' ? (
              <td>
                <span className='tooltip_wrap margin_right_20 coming_soon_table'>-</span>
              </td>
            ) : (
              <td>
                <span className='tooltip_wrap margin_right_20'>
                  <img
                    src={App_data.frontend_url + '/img/question_bank/eye_icon.svg'}
                    className='pointer_class'
                    alt=''
                    width='23'
                    onClick={this._getQuestions.bind(this, item)}
                    id={item.id}
                    title=''
                  />
                  <div className='tootip_box'>{language.LC().VIEW_LIST}</div>
                </span>

                <span className='tooltip_wrap'>
                  <img
                    src={App_data.frontend_url + '/img/question_bank/open_book_icon.svg'}
                    className='pointer_class'
                    alt=''
                    width='21'
                    id={item.id}
                    onClick={this._beginChapter.bind(this, item)}
                    title=''
                  />
                  <div className='tootip_box'>{language.LC().BEGIN_CHAPTER}</div>
                </span>
              </td>
            )}
          </tr>
        );
      });
    } else {
      data = <Loader />;
    }

    return (
      <div>
        <div className='animated fadeIn'>
          <div className='row'>
            <div className='col-md-8 margin_bottom_20'>
              <h1 className='section_head'>{this.state.chapterName}</h1>
            </div>
            <div className='col-md-4 text-md-right margin_bottom_20 question-download-reading-page'>
              <div onClick={this.getpdf.bind(this)} className='status-download-btn margin_right_10'>
                <a className='btn btn-primary  pointer_class pull-right'>
                  {this.state.pdfLoading ? (
                    <i className='fa fa-download' aria-hidden='true' />
                  ) : (
                    <i className='fa fa-spinner fa-spin' aria-hidden='true' />
                  )}
                  {this.state.showFreePremium ? (
                    <div className='premium-download'>{language.LC().PREMIUM}</div>
                  ) : null}
                  {this.state.pdfLoading ? language.LC().Download_Question : '  please wait...'}
                </a>
              </div>
              <div
                onClick={this.getpdfAnswer.bind(this)}
                className='status-download-btn margin_right_10'
              >
                <a className='btn btn-primary  pointer_class pull-right'>
                  {this.state.pdfLoadingAnswer ? (
                    <i className='fa fa-download' aria-hidden='true' />
                  ) : (
                    <i className='fa fa-spinner fa-spin' aria-hidden='true' />
                  )}
                  {this.state.showFreePremium ? (
                    <div className='premium-download'>{language.LC().PREMIUM}</div>
                  ) : null}
                  {this.state.pdfLoadingAnswer
                    ? language.LC().Download_Question_Answer
                    : '  please wait...'}
                </a>
              </div>

              <button
                type='button'
                className='btn btn-primary pointer_class'
                onClick={this._getChapters}
              >
                {' '}
                {language.LC().CHANGE_TOPIC}{' '}
              </button>
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12'>
              <div className='card height_70vh'>
                {/* <div className="card-header">
                                {language.LC().CHANGE_READING}
                            </div> */}

                <div className='table_responsive_wrapper'>
                  <div className='table-responsive'>
                    <table className='table_white_bg table'>
                      <thead>
                        <tr className='border_top_0'>
                          <th width='90'>#</th>
                          <th>{language.LC().READING}</th>
                          <th>{language.LC().ACTION}</th>
                        </tr>
                      </thead>
                      <tbody>{data}</tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
        />

        <QuestionNotFoundModal
          alert_status={this.state.alert_status_question_not_found}
          toggleAlert={this.toggleAlert}
          MessageTitle={this.state.MessageTitleOnQuestionNotFound}
          MessageContent={this.state.ComingSoon}
        />
        <PDFModelComponent
          type={this.state.PDFDownloadType}
          pdfAlertModel={this.pdfAlertModel.bind(this)}
          pdfAlert={this.state.pdfAlert}
          PDFContentMessage={this.state.PDFContentMessage}
        />
      </div>
    );
  }
}

export default GMATReadings;



// WEBPACK FOOTER //
// ./src/views/GMAT/QuestionBank/Readings.js